export class AppSettings {
    // CONEXION REST DESARROLLO
    //public static APIREST_ENDPOINT: string = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/acvis/ApiRest';

    /********************************************************************************************************** */
    /**
     * ENDPOINT DE CONEXIÒN AL SERVICIO INICIAL DE CONEXION QUE CONSUME TOKEN Y URL´S DE APLICACIÒN
     */

    //cambiar para entrega
     public static API_INIT_ENDPOINT:
         string = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/acvis-transversal/ApiRest';

    //public static API_INIT_ENDPOINT: string = 'http://localhost:7001/acvis-transversal/ApiRest';

    // /**
    //  * ENDPOITN DE CONEXIÒN AL BACKEND DE ACCVIS TRANSVERSAL
    //  */
    // public static APIREST_TRANSV_ENDPOINT = 'http://localhost:7001/acvis/ApiRest';
    // /**
    //  * ENDPOITN DE CONEXIÒN AL BACKEND DE ACCVIS (SOLAMENTE ACCESO A VISITANTES)
    //  */
    // public static APIREST_ACVIS_ENDPOINT = 'http://localhost:7001/acvis/ApiRest';
    // /**
    //  * ENDPOINT DE CONEXIÒN AL BACKEND DE UAC (SOLAMENTE UNIDAD DE ATENCION AL CIUDADANO)
    //  */
    // public static APIREST_UAC_ENDPOINT = 'http://localhost:7001/acvis-uac/ApiRest';

    // /**
    //  * ENDPOINT DE CONEXIÒN AL WEBSCOKET DEL TABLERO DE TURNOS (SOLAMENTE UNIDAD DE ATENCION AL CIUDADANO)
    //  */
    // public static WEBSOCKET_TURNOS_ENDPOINT = 'ws://localhost:7001/acvis-uac/tableroturnos';

    // /**
    //  * ENDPOINT DE CONEXIÒN AL BACKEND DE MODULO FUNCIONARIOS (solamente modulo funcionarios)
    //  */
    // // public static APIREST_FUNCIONARIOS_ENDPOINT = 'http://localhost:7001/acvis-funcionarios/ApiRest';

    // /*********************************************************************************************** */




    //ENDPOINTS DE CONEXION AMBIENTE PRUEBAS
    //*********************************************************************************************** */
    // PRUEBAS SARAP
    // public static APIREST_ENDPOINT1 = 'http://172.16.1.34:7001/acvis/ApiRest';
    // public static APIREST_ACVIS_ENDPOINT: string = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/acvis/ApiRest';
    // public static APIREST_UAC_ENDPOINT: string = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/acvis-uac/ApiRest';

    //PRUEBAS AMBIENTE SEGURO
    // public static APIREST_ENDPOINT = 'https://asesoftwaredev.eastus.cloudapp.azure.com/acvis/ApiRest';


    // public static APIREST_TRANSV_ENDPOINT = 'https://asesoftwaredev.eastus.cloudapp.azure.com/acvis/ApiRest';
    // public static APIREST_ACVIS_ENDPOINT = 'https://asesoftwaredev.eastus.cloudapp.azure.com/acvis/ApiRest';
    // public static APIREST_UAC_ENDPOINT = 'https://asesoftwaredev.eastus.cloudapp.azure.com//acvis-uac/ApiRest';
    // public static WEBSOCKET_TURNOS_ENDPOINT = 'wss://asesoftwaredev.eastus.cloudapp.azure.com/acvis-uac/tableroturnos';



    /********************************************************************************
     ********************************************************************************
     * ENDPOINTS ENTREGA
     ********************************************************************************
     ********************************************************************************/

    /**
     * ENDPOITN DE CONEXIÒN AL BACKEND DE ACCVIS TRANSVERSAL
     */
    // public static APIREST_TRANSV_ENDPOINT = location.protocol + '//'
    //    + location.hostname + (location.port ? ':' + location.port : '') + '/acvis/ApiRest';

    /**
     * ENDPOITN DE CONEXIÒN AL BACKEND DE ACCVIS (SOLAMENTE ACCESO A VISITANTES)
     */
    // public static APIREST_ACVIS_ENDPOINT = location.protocol + '//'
    //    + location.hostname + (location.port ? ':' + location.port : '') + '/acvis/ApiRest';

    /**
     * ENDPOINT DE CONEXIÒN AL BACKEND DE UAC (SOLAMENTE UNIDAD DE ATENCION AL CIUDADANO)
     */
    // public static APIREST_UAC_ENDPOINT = location.protocol + '//'
    //    + location.hostname + (location.port ? ':' + location.port : '') + '/acvis-uac/ApiRest';

    /**
     * ENDPOINT DE CONEXIÒN AL BACKEND DE MODULO FUNCIONARIOS (solamente modulo funcionarios)
     */
    // public static APIREST_FUNCIONARIOS_ENDPOINT = location.protocol + '//'
    //     + location.hostname + (location.port ? ':' + location.port : '') + '/acvis-funcionarios/ApiRest';

    /**
     * ENDPOINT DE CONEXIÒN AL WEBSCOKET DEL TABLERO DE TURNOS (SOLAMENTE UNIDAD DE ATENCION AL CIUDADANO)
     */
    // public static WEBSOCKET_TURNOS_ENDPOINT = 'ws://' + location.hostname
    //    + (location.port ? ':' + location.port : '') + '/acvis-uac/tableroturnos';

}
